import { render } from "./BlogManagement.vue?vue&type=template&id=9786a62e&scoped=true"
import script from "./BlogManagement.vue?vue&type=script&lang=js"
export * from "./BlogManagement.vue?vue&type=script&lang=js"

import "./BlogManagement.vue?vue&type=style&index=0&id=9786a62e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9786a62e"]])

export default __exports__